import { useState, useEffect } from 'react';
import './estimator.css'
import PropularProduct from '../components/popularProd';
import Talk from '../components/talk';
import { useLocation, useNavigate} from 'react-router-dom'
import axios from 'axios';

const estimatorCalculator = async(given)=>{
    let model = false
    console.log(given.model)
    const getUnitPrice = async(bill)=>{
        switch(true){
            case bill<1880 :
                return 4.7; 
            case bill>1880 && bill<3150 :
                return 6.3;
            case bill>3150 && bill<5040:
                return 8.4;
            case bill>3150 && bill<7560:
                return 9.45;
            case bill>7560 && bill<10500:
                return 10.5;
            case bill>10500:
                return 11.55;
        }
    }  

    const getKWGenOn = async(unit)=>{
        switch(true){ 
            case unit<3:
                return 3;
            case unit>3 && unit<5 :
                return 5;
            case unit>5 && unit<10 :
                return 10;
            case unit>10 && unit<15 :
                return 15;
            case unit>15 && unit<25 :
                return 25;
            case unit>25 && unit<50 :
                return 50;
            case unit>50 && unit<75 :
                return 75;
            case unit>75 && unit<100 :
                return 100;
            case unit>100 && unit<150 :
                return 150;
            case unit>150 && unit<200 :
                return 200;
            case unit>200 && unit<250 :
                return 250;
            case unit>250 && unit<300 :
                return 300;
            case unit>300 && unit<350 :
                return 350;
            case unit>350 && unit<400 :
                return 400;
            case unit>400 && unit<450 :
                return 450;
            case unit>450 && unit<500 :
                return 500;
            case unit>500 && unit<550 :
                return 550;
            case unit>550 && unit<600 :
                return 600;
            case unit>600 && unit<650 :
                return 650;
            case unit>650 && unit<700 :
                return 700;
            case unit>700 && unit<750 :
                return 750;
            case unit>750 && unit<800 :
                return 800;
            case unit>800 && unit<850 :
                return 850;
            case unit>850 && unit<900 :
                return 900;
            case unit>900 && unit<950 :
                return 950;
            case unit>950:
                return 1000;
            
        }
    }  

    const getKWGenOff = async(unit)=>{
        switch(true){
            case unit<1.5 :
                return 1; 
            case unit>1.5 && unit<3 :
                return 3;
            case unit>3 && unit<5 :
                return 5;
            case unit>5 && unit<10 :
                return 10;
            case unit>10 && unit<15 :
                return 15;
            case unit>15:
                model = "To_ON"
               return getKWGenOn(unit)

        }
    }  

    const unitPrice = await getUnitPrice(parseInt(given.bill));
    const unit = ((parseInt(given.bill)/(unitPrice*30))).toFixed(0);
    console.log(given.model)
    const kWgen = await (given.model?getKWGenOff(parseInt(unit)/4):getKWGenOn(parseInt(unit)/4))
    
    return {power:kWgen, unitPrice:unitPrice, model:model};

}

export default function Estimator(){
    const location = useLocation()
    const homeEst = location.state

    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
          window.scrollTo(0, 0);
        };
      }, []); 
    const [estpage, setEstPage] = useState({
        pincode:'',
        bill:'',
        area:'',
        type:'',
        model:false
    })
    const formatter = new Intl.NumberFormat('en-IN');
    const [estimated, setEstimated]=useState({
        amount:0,
        plan:0,
        saving:"xxxx",
        reqArea:"xxx",
        genWatt:"xxxx",
        district:"",
        module:false

    })
    const estiChange = (e) =>{
        const {name, value} = e.target;
        setEstPage((preData)=>({
            ...preData,
            [name]:value
        }))
    }
    const estiChangeCheck = (e) =>{
        const {name, checked}=e.target;
        setEstPage((preData)=>({
            ...preData,
            [name]:checked
        }))
    }
    const [loadingest, setLoadingest] = useState(false)
    const [estimatedDiv, setEstimatedDiv] = useState(false)
    const submitEst = async(e) =>{
        e.preventDefault()
        setLoadingest(true)
        const response = await axios.get(`https://api.postalpincode.in/pincode/${estpage.pincode}`)
        
        if(response.status===200){
            setEstimatedDiv(true)
            setLoadingest(false)            
            if (response.data[0].PostOffice){
                const {power, unitPrice, model} = await estimatorCalculator(estpage)
                console.log(model)
                setEstimated((preData)=>({
                    ...preData,
                    amount:formatter.format(model||estpage.model?power*67000:power*82000),
                    plan:power,
                    saving:(5.2*30*12*unitPrice).toFixed(0),
                    reqArea:power*100,
                    genWatt:power*30*4,
                    district:response.data[0].PostOffice[0].District,
                    model:model
                }))
            }else{
                console.log("not Valid")
            }
        }
    }

    useEffect(()=>{
        const callFromHome = async()=>{
            setLoadingest(true)
            const response = await axios.get(`https://api.postalpincode.in/pincode/${homeEst.pincode}`)
            console.log(response)
            if(response.status===200){
                setEstimatedDiv(true)
                setLoadingest(false)            
                if (response.data[0].PostOffice){
                    const {power, unitPrice, model} = await estimatorCalculator(homeEst)
                    setEstimated((preData)=>({
                        ...preData,
                        amount:formatter.format(model||homeEst.model?power*67000:power*82000),
                        plan:power,
                        saving:(5.2*30*12*unitPrice).toFixed(0),
                        reqArea:power*100,
                        genWatt:power*30*4,
                        district:response.data[0].PostOffice[0].District,
                        model:model
                    }))
                }else{
                    console.log("not Valid")
                }
            }
        }
        homeEst && callFromHome()
    },[homeEst])
    
    return(
        <>
        <div className='estimatorWrapper'>
            <div className='estimatorContainer'>
                <div className='estimator'>
                    <div className='stripText'>
                        <div className='before'></div>
                        <h1><span className='span1'>LET’S PLAN YOUR</span> <span className='span2'>SOLAR</span></h1>
                        <div className='after'></div>
                    </div>
                    <div  className='formcontainer'>
                        <form onSubmit={submitEst}>
                            <div className='formRow'>
                                <div className='est-input-container'>
                                    <label>Pincode</label>
                                    <input
                                        type='text'
                                        name='pincode'
                                        value={estpage.pincode}
                                        onChange={estiChange}
                                        minLength="6"
                                        maxLength="6"
                                        pattern='[0-9]*'
                                        required
                                    />
                                </div>
                                <div className='est-input-container'>
                                    <label>Average Bill</label>
                                    <input
                                        type='number'
                                        name='bill'
                                        value={estpage.bill}
                                        onChange={estiChange}
                                        required
                                    />
                                </div>
                                <div className='est-input-container'>
                                    <label>Available Area</label>
                                    <input
                                        type='number'
                                        name='area'
                                        value={estpage.area}
                                        onChange={estiChange}
                                        required
                                    />
                                </div>
                            </div>
                            <div className='formRow'>
                                <div className='est-input-container'>
                                    <label>Available Area</label>
                                    <select
                                        name='type'
                                        value={estpage.type}
                                        onChange={estiChange}
                                    >                                        
                                        <option value='residential'>Residential</option>
                                        <option value='commercial'>Commercial</option>
                                    </select>
                                </div>
                                <div className='est-input-container est-check'>
                                <label>Power Backup</label>
                                    <input
                                        type='checkbox'
                                        name='model'
                                        value={estpage.model}
                                        checked={estpage.model}
                                        onChange={estiChangeCheck}
                                    />
                                </div>
                                <div className='est-input-container est-sumbit'>
                                    <br/>
                                    <input
                                        type='submit'
                                        value='Submit'
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    {estimated.model && <p style={{color:"red", fontSize:".8rem"}}>*Power backup is not available for system that generate more than 15 KW</p>}
                    <div className='est-image-container' >
                        <img src='./images/estImage.png' alt='Panel'/>
                    </div>
                </div>



            </div>
            <div className='whatToShowEstimated'>
                {estimatedDiv?(
                <div className='estimated'>
                    <div className='saving-details'>
                        <div className='estiHeader'>
                            <h1>Your Solar Plan is {estimated.plan} KW</h1>
                            <p>{estimated.district}</p>
                        </div>
                        <div className='piggyContainer'>
                            <div className='piggy'>
                                <div className='piggyImage'>
                                    <img src='./images/piggy.svg' alt=''/>
                                </div>
                                <h2>Rs {estimated.saving}</h2>
                                <p>Annually Savings</p>
                            </div>
                            <div className='piggy'>
                                <div className='piggyImage'>
                                    <img src='./images/estiSolar.svg' alt=''/>
                                </div>
                                <h2>{estimated.reqArea} Sqft</h2>
                                <p>Required Area</p>
                            </div>
                            <div className='piggy'>
                                <div className='piggyImage'>
                                    <img src='./images/monthlyEnergy.svg' alt=''/>
                                </div>
                                <h2>{estimated.genWatt} W</h2>
                                <p>Monthly Generation</p>
                            </div>
                        </div>
                        <div className='estSpecifications'>
                            <h2>Critical Note</h2>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer sodales metus ut diam placerat efficitur.</p>
                            <h2>Specification</h2>
                            <p>
                                <ul>
                                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                    <li>Curabitur non mauris quis urna lobortis congue et quis ex.</li>
                                    <li>Mauris feugiat augue in turpis pharetra elementum.</li>
                                    <li>Nullam pulvinar lorem in est molestie dignissim.</li>
                                    <li>Aliquam et tellus eu neque condimentum placerat sit amet vitae turpis.</li>
                                    <li>Nam a metus quis orci semper condimentum at sit amet dui.</li>
                                    <li>Curabitur gravida est at cursus gravida.</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                    <div className='saving-money'>
                        <div className='est-price'>
                            <h1>Rs. {estimated.amount}</h1>
                            <p>Estimated Price</p>
                        </div>
                        <div className='estiTerms'>
                            <p>
                                Easy EMI Available<br/>
                                Price Included Installation<br/>
                                Teams to be added<br/>
                                Teams to be added<br/>
                            </p>
                        </div>
                        <div className='estiTalkBtn'>
                            <button>Let's Talk</button>
                        </div>
                    </div>
                </div>
            ):(
            <div className='estimated'>
                <div className='fillForm'>
                    <h1>Fill the Above Form <br/>Get an Estimation</h1>
                </div>
            </div>
            )}
            </div>
            {/* <div className={estimatedDiv?'estimated show':'estimated hide'}>
                <div className='saving-details'>
                    <div className='estiHeader'>
                        <h1>Your Solar Plan is 4 KW</h1>
                        <p>Vellore</p>
                    </div>
                    <div className='piggyContainer'>
                        <div className='piggy'>
                            <div className='piggyImage'>
                                <img src='./images/piggy.png' alt=''/>
                            </div>
                            <h2>Rs 2000</h2>
                            <p>Monthly Savings</p>
                        </div>
                        <div className='piggy'>
                            <div className='piggyImage'>
                                <img src='./images/piggy.png' alt=''/>
                            </div>
                            <h2>350 Sqft</h2>
                            <p>Required Area</p>
                        </div>
                        <div className='piggy'>
                            <div className='piggyImage'>
                                <img src='./images/piggy.png' alt=''/>
                            </div>
                            <h2>500 W</h2>
                            <p>Monthly Generation</p>
                        </div>
                    </div>
                    <div className='estSpecifications'>
                        <h2>Critical Note</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer sodales metus ut diam placerat efficitur.</p>
                        <h2>Specification</h2>
                        <p>
                            <ul>
                                <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                                <li>Curabitur non mauris quis urna lobortis congue et quis ex.</li>
                                <li>Mauris feugiat augue in turpis pharetra elementum.</li>
                                <li>Nullam pulvinar lorem in est molestie dignissim.</li>
                                <li>Aliquam et tellus eu neque condimentum placerat sit amet vitae turpis.</li>
                                <li>Nam a metus quis orci semper condimentum at sit amet dui.</li>
                                <li>Curabitur gravida est at cursus gravida.</li>
                            </ul>
                        </p>
                    </div>
                </div>
                <div className='saving-money'>
                    <div className='est-price'>
                        <h1>Rs. 1,26,000</h1>
                        <p>Estimated Price</p>
                    </div>
                    <div className='estiTerms'>
                        <p>
                            Easy EMI Available<br/>
                            Price Included Installation<br/>
                            Teams to be added<br/>
                            Teams to be added<br/>
                        </p>
                    </div>
                    <div className='estiTalkBtn'>
                        <button>Let's Talk</button>
                    </div>
                </div>
            </div> */}
            <div className='popular-products'>
                <h1>Popular Product</h1>
            </div>
            <div className='pop-container estPOP'>
                    <PropularProduct/>
            </div>
            <div className='contactUS estTAlk'>
                <Talk/>
            </div>
        </div>
        <div className={loadingest?'estloadingContainer showFlex':'estloadingContainer hide'}>
            <div className='estloadingBG'></div>
            <div className='estloading'>
                <img src='../images/loading.png' />
            </div>
        </div>
        </>
    );
}